import type { Editor } from '../../../public/tinymce/tinymce.d.ts';

type DialogApi = {
  getData: () => {
    title: string;
    description: string;
    content: string;
    embed: string;
  };
  setData: (data: { embed: string }) => void;
  close: () => void;
};

type EmbedDialogConfig = {
  title: string;
  size: 'large';
  body: {
    type: 'panel';
    items: Array<{
      type: 'input' | 'textarea' | 'iframe';
      name: string;
      label: string;
      sandboxed?: boolean;
    }>;
  };
  buttons: Array<{
    type: 'cancel' | 'submit';
    name: string;
    text: string;
    buttonType?: 'primary';
  }>;
  initialData: {
    title: string;
    description: string;
    embed: string;
  };
  onChange: (api: DialogApi) => void;
  onSubmit: (api: DialogApi) => void;
};

export const sanitizeScripts = (e: { content: string }): void => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(e.content, 'text/html');
  const scripts = doc.querySelectorAll('script');

  scripts.forEach((script) => {
    if (script.id) return;
    if (script.type !== 'application/ld+json') {
      script.remove();
    }
  });

  e.content = doc.body.innerHTML + doc.head.innerHTML;
};

export const getEmbedDialogConfig = (
  editor: Editor,
  onSubmit?: (content: string, title?: string) => void,
): EmbedDialogConfig => ({
  title: 'Insert Embed',
  size: 'large',
  body: {
    type: 'panel',
    items: [
      {
        type: 'input',
        name: 'title',
        label: 'Title',
      },
      {
        type: 'textarea',
        name: 'description',
        label: 'Description',
      },
      {
        type: 'textarea',
        name: 'content',
        label: 'Paste your embed code below:',
      },
      {
        type: 'iframe',
        name: 'embed',
        label: 'Preview',
        sandboxed: true,
      },
    ],
  },
  buttons: [
    {
      type: 'cancel',
      name: 'closeButton',
      text: 'Cancel',
    },
    {
      type: 'submit',
      name: 'submitButton',
      text: 'Embed',
      buttonType: 'primary',
    },
  ],
  initialData: {
    title: '',
    description: '',
    embed: '',
  },
  onChange: (api: DialogApi) => {
    const { content } = api.getData();
    api.setData({ embed: content });
  },
  onSubmit: (api: DialogApi) => {
    const { title, description, embed } = api.getData();

    let content = embed;
    if (description) content += `<p>${description}</p>`;

    if (onSubmit) {
      onSubmit(content, title);
    } else {
      editor.insertContent(content);
    }

    api.close();
  },
});

export const getGameRecapUrl = (editor: Editor): object => ({
  title: 'Insert a link',
  body: {
    type: 'panel',
    items: [
      {
        type: 'input',
        name: 'url',
        label: 'URL',
      },
    ],
  },
  buttons: [
    {
      type: 'cancel',
      text: 'Cancel',
    },
    {
      type: 'submit',
      text: 'Insert',
      buttonType: 'primary',
    },
  ],
  onSubmit: (api: any) => {
    const data = api.getData();
    const { url } = data;

    if (url) {
      editor.insertContent(
        `Δείτε <a target="_blank" 
        rel="noopener"
        href="${url}">εδώ</a> το recap του αγώνα`,
      );
    }

    api.close();
  },
});
